import React from "react";
import { useTranslation } from "react-i18next";

//MUI
import Fab from "@mui/material/Fab";
import Button, { ButtonProps } from "@mui/material/Button";

//MUI Icons
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

export interface IToggleTableButtonProps  {
  open: boolean;
  disabled: boolean;
  onClick: (evt: React.MouseEvent<HTMLButtonElement>, newValue: boolean) => void;
}

const ToggleTableButton = (props: IToggleTableButtonProps) => {

  const { t } = useTranslation();

  const { open, disabled, onClick } = props;

  const handleClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    onClick(evt, open ? false : true);
  }

  return (
    <Fab
      color="primary"
      size="small"
      onClick={handleClick}
      disabled={disabled}
    >
      {open ? <KeyboardDoubleArrowUpIcon /> : <KeyboardDoubleArrowDownIcon />}
    </Fab>
  );

  return (

    <Button
      color="primary"
      size="medium"
      variant="contained"
      sx={{
        mx: 1,
        width: 200
      }}
      endIcon={
        open ? <KeyboardDoubleArrowUpIcon /> : <KeyboardDoubleArrowDownIcon />
      }
      onClick={handleClick}
    >
      {open ? t("operations.toggle_closetable") : t("operations.toggle_opentable")}
    </Button>
  );

}

export default ToggleTableButton;